module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.ee45fdca.woff";